import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Jumbotron/Jumbotron';

class Jumbotron extends React.Component {
  render() {
    let centerClass = this.props.section.prop('height') < 300 ? '' : 'vertical-centered';
    return (
      <section
        className={'jumbotron ' + centerClass + ' ' + this.props.loadAnimation}
        style={this.props.styles}
      >
        <div className={this.props.actionAnimation || ''}>
          <InlineEditableElement
            fontFamilyChanged={this.props.fontFamilyChanged.bind(this)}
            size={this.props.size}
            className="container"
            el="div"
            onChange={this.props.valueChanged.bind(this)}
            html={this.props.section.prop('content')}
            inlineEditingEnabled={this.props.inlineEditingEnabled}
          />
        </div>
        <div className="overlay" />
      </section>
    );
  }
}

export default hoc(Jumbotron);
